export function useShowAction() {
  const showAction = (item, type: string) => {
    return item?.conversionCountByType && item?.conversionCountByType[type] > 0
  }

  return { showAction }
}
